import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/main.css'
import '@/monitor-console/styles/variables.css'
import '@/monitor-console/styles/theme-light.css'
import { initTheme } from '@/utils/themeManager'
import sessionManager from '@/utils/login/sessionManager'
import { initNativeAppBehavior } from '@/utils/nativeAppBehavior'

initTheme()
sessionManager.initSessionRefresh()
initNativeAppBehavior()
import VueKonva from 'vue-konva'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(ElementPlus)
app.use(VueKonva)
app.mount('#app')
